import React from 'react';
import PropTypes from 'prop-types';
import { isValidArray } from '../../../utilities/validations';

const Product = (props) => {
	if (!props.product?.price?.consumer?.amount && !props.ratingValue && !isValidArray(props.customerReviews)) return null;

	const reviews = isValidArray(props.customerReviews) ? props.customerReviews.slice(-5).reverse() : [];
	const price = props.product?.price?.consumer?.amount && props.product.price.consumer.amount / 100;

	const images = isValidArray(props.images) ? props.images : [props.images];

	return (
		<script
			type='application/ld+json'
			dangerouslySetInnerHTML={{
				__html: `{
				"@context": "https://schema.org",
				"@type": "Product",
				"name": "${props.name}",
				"description": "${props.description?.replace(/"/g, "'") || ''}",
				"image": ${JSON.stringify(images)},
				"brand": {
					"@type": "Brand",
					"name": "Pella"
				},
				"gtin": "${props.product.gtin || ''}",
				"mpn": "${props.product.mpn || ''}"
				${
					(props.ratingValue &&
						`,
				"aggregateRating": {
					"@type": "AggregateRating",
					"ratingValue": "${props.ratingValue || ''}",
					"reviewCount": "${props.ratingCount || ''}"
				}`) ||
					''
				}${
					(isValidArray(reviews) &&
						`,
				"review": [
					${reviews.map(review => `{
						"@type": "Review",
						"reviewRating": {
							"@type": "Rating",
							"ratingValue": "${review.OverallSatisfactionRating}",
							"bestRating": "5"
						},
						"author": {
							"@type": "Person",
							"name": "${review.CustomerFirstName} ${review.CustomerLastName}"
						},
						"datePublished": "${review.DateSurveyed.split('T')[0]}",
						"reviewBody": "${review.MemorableAspects}"
					}`).join(',')}
				]`) ||
					''
				}${
					(price != 0 &&
						`,
				"offers": {
					"@type": "Offer",
					"url": "https://www.pella.com${props.productUrl}",
					"itemCondition": "https://schema.org/NewCondition",
					"availability": "${props.product.available_online ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock'}",
					"price": "${price}",
					"priceCurrency": "USD"
				}`) ||
					''
				}
			}`,
			}}
		/>
	);
};

Product.propTypes = {
	name: PropTypes.string,
	description: PropTypes.string,
	brand: PropTypes.string,
	images: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	ratingValue: PropTypes.number,
	ratingCount: PropTypes.number,
	reviewRatingValue: PropTypes.number,
	customerReviews: PropTypes.array,
	productUrl: PropTypes.string,
	product: PropTypes.object,
};

export default Product;